module.exports = __webpack_public_path__ + "img/ex2.cba45bad.jpg";